"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _redux = require("../redux");
const ALLOWED_TYPES = ["string", "number", "boolean", "undefined"];
const initialState = {
  value: undefined
};
const setValue = (0, _toolkit.createAction)("setValue");
const reduceValue = function (state, _ref) {
  let {
    payload
  } = _ref;
  return {
    ...state,
    value: payload
  };
};
const getValue = function (state) {
  return state.value;
};
const reducer = (0, _toolkit.createReducer)(initialState, {
  [setValue]: reduceValue
});
var _default = exports.default = function _default(id) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    initialState: "",
    persist: false
  };
  const [select, dispatch] = (0, _redux.useReducerManager)({
    id,
    reducer,
    initialState: {
      value: options === null || options === void 0 ? void 0 : options.initialState
    },
    persist: options === null || options === void 0 ? void 0 : options.persist
  });
  const setState = function (value) {
    const valueType = typeof value;
    if (ALLOWED_TYPES.indexOf(valueType) === -1) {
      console.error(`Invalid type passed to useSimpleReducer. Type passed: ${valueType}`);
      return false;
    }
    dispatch(setValue(value));
  };
  return [select(getValue), setState];
};